import React, {useState, useEffect} from 'react';
import { Row, List, Col} from 'antd';
import './css/product.css';

function Documentation(props){

    useEffect(()=>{
        if(props.productId !== 0){
            if(props.product.length>0){
                for(var i = 0; i<=(props.product.length-1); i++){
                    if(props.product[i].id === props.productId){
                        try{
                            var request = JSON.parse(props.product[i].request);
                            if(request == null){
                                setRequest("");
                            }else{
                                setRequest(JSON.stringify(request,null,5));
                            }
                        }catch{
                            setRequest(props.product[i].request);
                        }
                        var inbound =  props.product[i].inbound;
                        var responseSuccess = props.product[i].ResponseSuccess; 
                        var responseFail = props.product[i].ResponseFailed; 
                        setDoc(props.product[i].doc);
                        setResponseSuccess(responseSuccess);
                        setResponseFailed(responseFail);
                        if (inbound.toLowerCase().includes("payment")) {
                            setPayment(true);
                        }else{
                            setPayment(false);
                        }
                    }
                }
            }
        }
    },[props.productId, props.product]);

    const [focusResponce, setFocusResponce] = useState(1);
    const [doc, setDoc] = useState("");
    const [request, setRequest] = useState("");
    const [responseSuccess, setResponseSuccess] = useState("");
    const [responseFailed, setResponseFailed] = useState("");
    const [paymentType, setPayment] = useState(false);
    const handleResponceConditionClick = list => {
        setFocusResponce(list);
    }

    const responce_condition = [
        {
            title: "Success",
            key:1,
          },
          {
            title: "Fail",
            key:2,
          },
    ];

    

    let className_responce_c = "responce_condition_item";
    let className_responce_c_focus = "responce_condition_item focus_responce_con";

    const responces = {
        1: responseSuccess,
        2: responseFailed,
    }
    
    return (
        <div>
            <Row>
                <Col xs={24} sm={24} md={24} lg={15} xl={15} style={{overflowX:'scroll'}}>
                    <div dangerouslySetInnerHTML={{__html: doc}} />
                </Col>
                <Col xs={24} sm={24} md={24} lg={9} xl={9} style={{backgroundColor:'#292929', margin:"15px 0px"}}>
                    <div className="request_example">
                        <p className="request_example_title">Request example</p>
                        {!paymentType ? 
                            <ul className="request_example_ul">
                                <li>Authorization : Bearer xxxxx</li>
                                <li>Content-Type : application/json</li>
                            </ul>
                            : 
                            <></>
                        }
                        <div className="separate_request">
                            <p className="request_condition_item">Request</p>
                        </div>
                        <pre className="request_example_data">{request}</pre>
                    </div>
                    <hr style={{marginBottom:"0px"}}/>
                    <div className="responce_example">
                        <p className="responce_example_title">Response example</p>
                        <List
                            grid={{ column:2 }}
                            dataSource={responce_condition}
                            className="responce_condition"
                            renderItem={item => (
                                <List.Item key={item.key} onClick={()=> handleResponceConditionClick(item.key)} className={ item.key === focusResponce ? className_responce_c_focus : className_responce_c }>
                                    <span className="responce_condition_text">{item.title}</span>
                                </List.Item>
                            )}
                        />
                        <pre className="responce_example_data">{responces[focusResponce]}</pre>
                    </div>
                </Col>
            </Row>
        </div>
    );
}

export default Documentation;